import { useEffect, useRef } from 'react';

import { COMMON_DEFAULT_VALUES } from './useDetailsDefaultValues';
import { useDetailsSchema } from './useDetailsSchema';
import { useForm } from '../../../form/useForm';
import {
	DetailsDefaultValues,
	IDetailsFormData,
} from '../types/IDetailsFormData';
import { UNITED_STATES } from '../../../constants/UnitedStates';

interface IOptions {
	defaultValues?: DetailsDefaultValues;
	requiresConsent: boolean;
}

export function useDetailsForm({ defaultValues, requiresConsent }: IOptions) {
	const isInitialRender = useRef(true);
	const validationSchema = useDetailsSchema({ requiresConsent });
	const form = useForm<IDetailsFormData>({
		mode: 'onSubmit',
		defaultValues: defaultValues ?? COMMON_DEFAULT_VALUES,
		validationSchema,
	});

	useEffect(
		() => {
			if (!isInitialRender.current) {
				form.reset(getAdaptedDefaultValues());
			}

			isInitialRender.current = false;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[defaultValues],
	);

	const getAdaptedDefaultValues = () => {
		if (!defaultValues) return COMMON_DEFAULT_VALUES;

		const defaultState = UNITED_STATES.find(
			(item) => item.abbreviation === defaultValues?.state,
		);
		return {
			...defaultValues,
			state: defaultState?.name,
		};
	};
	return form;
}
